import { Controller } from "@hotwired/stimulus"
import { Html5Qrcode } from "html5-qrcode"

export default class extends Controller {
  static targets = ["input", "error", "reader", "status", "cameraBtn"]

  connect() {
    this.scanner  = null
    this.scanning = false

    // Ensure reader target has an id (required by Html5Qrcode)
    if (!this.readerTarget.id) {
      this.readerTarget.id = 'barcode-reader-' + Math.random().toString(36).slice(2)
    }

    // USB scanner – fire on Enter key
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return
        e.preventDefault()
        const code = this.inputTarget.value.trim()
        if (code) this.onDetected(code)
      })
    }
  }

  toggleCamera() {
    this.scanning ? this.stopScanner() : this.startScanner()
  }

  async startScanner() {
    this.clearError()
    try {
      this.scanner = new Html5Qrcode(this.readerTarget.id)
      this.scanning = true
      this.readerTarget.classList.remove('d-none')
      this.cameraBtnTarget.textContent = '⏹️ Stop'
      this.cameraBtnTarget.classList.replace('btn-primary', 'btn-danger')
      this.statusTarget.textContent = 'Skanuję... skieruj kod na kamerę.'

      await this.scanner.start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 260, height: 120 } },
        (code) => this.onDetected(code),
        () => {} // per-frame "not found" – ignore
      )
    } catch (err) {
      this.showError('Błąd kamery: ' + err)
      this.stopScanner()
    }
  }

  async stopScanner() {
    this.scanning = false
    if (this.scanner) {
      try { await this.scanner.stop() } catch (_) {}
      this.scanner.clear()
      this.scanner = null
    }
    this.readerTarget.classList.add('d-none')
    this.cameraBtnTarget.textContent = '📷 Uruchom kamerę'
    this.cameraBtnTarget.classList.replace('btn-danger', 'btn-primary')
    this.statusTarget.textContent = ''
  }

  onDetected(code) {
    this.inputTarget.value = code
    // Fire native input event so other controllers (e.g. assignment-search) react
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.stopScanner()
    // Dispatch custom Stimulus event for controllers that listen explicitly
    this.dispatch('scanned', { detail: { code }, bubbles: true, cancelable: false })
  }

  showError(msg) {
    this.errorTarget.textContent = msg
    this.errorTarget.classList.remove('d-none')
  }

  clearError() {
    this.errorTarget.classList.add('d-none')
    this.errorTarget.textContent = ''
  }

  disconnect() {
    if (this.scanning) this.stopScanner()
  }
}
